// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class PharmacyCardFinderResultSearchBase {
    static getAttributeTypeMap() {
        return PharmacyCardFinderResultSearchBase.attributeTypeMap;
    }
}
PharmacyCardFinderResultSearchBase.discriminator = undefined;
PharmacyCardFinderResultSearchBase.additionalProperties = false;
PharmacyCardFinderResultSearchBase.attributeTypeMap = [
    {
        "name": "result",
        "baseName": "result",
        "type": "PharmacyCardFinderResponse"
    },
    {
        "name": "clientId1",
        "baseName": "clientId1",
        "type": "string"
    },
    {
        "name": "clientId2",
        "baseName": "clientId2",
        "type": "string"
    },
    {
        "name": "clientId3",
        "baseName": "clientId3",
        "type": "string"
    },
    {
        "name": "clientId4",
        "baseName": "clientId4",
        "type": "string"
    },
    {
        "name": "clientId5",
        "baseName": "clientId5",
        "type": "string"
    },
];
//# sourceMappingURL=pharmacyCardFinderResultSearchBase.js.map